import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function WhyChooseUs() {
  return (
    <Box sx={{ py: 10 }}>
      <Container>
        <Typography variant="h4" gutterBottom>
          Why Choose Nerdshub?
        </Typography>

        {[
          ["Expertise", "Seasoned developers with API and microservices experience."],
          ["Innovation", "Future-ready, scalable, secure solutions."],
          ["Support", "24x7 SLA-based enterprise support."],
        ].map(([title, desc]) => (
          <Accordion key={title}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography color="grey.400">{desc}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}
